import React, { FC, useEffect, useState } from 'react';

import {
  parseDate,
  FormatFunction,
  getInputValue,
} from '@datepicker-react/hooks';

import { Col } from '@components/formStyles';
import { CalendarIcon } from '@assets/icons';

import {
  Error,
  InputWrapper,
  Label,
  Mask,
  StyledCustomIcon,
} from './DateInputStyle';

export interface DateInputProps {
  date: Date | null;
  disabled?: boolean;
  errorMessage?: string;
  setDate(date: Date | null): void;
  dateFormat: FormatFunction | string;
  label: string;
  placeholder?: string;
}

const DATE_LENGTH = 10;

const DateInput: FC<DateInputProps> = ({
  disabled,
  errorMessage,
  setDate,
  date,
  dateFormat = 'dd/MM/yyyy',
  label,
  placeholder,
}) => {
  const [searchString, setSearchString] = useState(
    getInputValue(date, dateFormat, '')
  );
  const [error, setError] = useState(errorMessage);

  useEffect(() => {
    const newDate = getInputValue(date, dateFormat, '');
    setSearchString(newDate);
  }, [date, dateFormat]);

  const handleChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchString(target.value);
    if (target.value.length === DATE_LENGTH) {
      const parsedDate = parseDate(
        target.value,
        String(dateFormat),
        new Date()
      );
      if (!isNaN(Number(parsedDate))) {
        setDate(parsedDate);
        setError('');
      } else {
        setDate(null);
        setSearchString('');
        setError('Geçerli bir tarih giriniz.');
      }
    }
  };

  const handleBlur = (): void => {
    if (searchString.length !== DATE_LENGTH) {
      setDate(null);
      setSearchString('');
    }
  };

  return (
    <>
      <InputWrapper>
        <StyledCustomIcon
          icon={CalendarIcon}
          fontSize={28}
          paletteColor='primaryBrand'
        />

        <Col>
          <Mask
            disabled={disabled}
            error={Boolean(error)}
            guide={false}
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            onBlur={handleBlur}
            onChange={handleChange}
            type='text'
            value={searchString}
            placeholder={placeholder}
          />
          <Label>{label}</Label>
        </Col>
      </InputWrapper>
      {error && <Error>{error}</Error>}
    </>
  );
};

export default DateInput;
